
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import MutableInputContainer from '@/components/inputs/MutableInputContainer.vue';

import moment from 'moment';
import userx from '@/store/modules/userx';
import mwx from '@/store/modules/mediumwarex';
import * as uuid from 'uuid';

import {
	AccountData,
	SoftwareType,
	EditState,
	MwToken,
} from '@/store/models.def';

@Component({
	components: {
		MutableInputContainer,
	},
})
export default class AccountToken extends Vue {
	@Prop() public token!: MwToken | null;

	public collapseId = 'c' + uuid.v4();
	public copied = false;

	public get supportLvl() {
		return userx.supportLvl;
	}

	public get createdAt(): string {
		if (!this.token) {
			return '';
		}
		return moment(this.token.createdAt).format('DD/MM/YYYY HH:mm:ss');
	}
	public get forbidden() {
		if (!this.token) {
			return false;
		}
		return this.token.forbidden;
	}

	public checked: boolean = this.forbidden || false;

	@Watch('forbidden', { immediate: true })
	public onForbiddenChanged(val: EditState, oldVal: EditState) {
		this.checked = this.forbidden!;
	}

	public onChange() {
		if (!this.token) {
			return;
		}
		this.$emit('change', this.token.id!, this.checked);
	}

	public async copyKey() {
		if (!this.token) {
			return;
		}
		try {
			await navigator.clipboard.writeText(this.token.key);
			this.copied = true;
			setTimeout(() => {
				this.copied = false;
			}, 2000);
		} catch (err) {
			console.error('Failed to copy key:', err);
		}
	}
}
